import { render, staticRenderFns } from "./SuperAdminSwitcher.vue?vue&type=template&id=7d09fad1&scoped=true"
import script from "./SuperAdminSwitcher.vue?vue&type=script&lang=js"
export * from "./SuperAdminSwitcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d09fad1",
  null
  
)

export default component.exports